import { Chipset } from '../components/types/stylepacks';
import { Entity } from '../types/interfaces';
import { getEmbedSafeHeaders } from './auth';
import blpAuth from './blp-auth';
import { getApiHost, getSyncHost } from '../utils/hosts';
import logger from '../utils/logger-rum';

export const GetChipset = (
	channel: number,
	contentId: number
): Promise<Chipset | null> => blpAuth.get({
	url: `/v3/greenroom/${channel}/content-chipset/${contentId}`,
	host: getApiHost(),
	token: blpAuth.accessToken,
	options: { headers: getEmbedSafeHeaders() },
}).catch(() => {
	return null;
}).then((res) => res);

export const SetChipset = (
	channel: number,
	contentId: number,
	userId: number
): Promise<boolean> => (
	blpAuth.put({
		url: `/v3/greenroom/${channel}/content-chipset/${contentId}/user/${userId}`,
		host: getApiHost(),
		token: blpAuth.accessToken,
		options: { headers: getEmbedSafeHeaders() },
	}).catch((err) => {
		logger.error('Error', err);
		return false;
	}).then((res) => {
		return res.status === 200;
	})
);

export const SetChip = (
	channel: number,
	content: number,
	dataKey: string,
	type: string
): Promise<boolean> => (
	blpAuth.put({
		url: `/v3/greenroom/${channel}/content-chip/${content}/key/${dataKey}/type/${type}`,
		host: getApiHost(),
		token: blpAuth.accessToken,
		options: { headers: getEmbedSafeHeaders() },
	}).catch((err) => {
		logger.error('Error', err);
		return false;
	}).then((res) => {
		return res.status === 200;
	})
);

export const DeleteChip = (
	channel: number,
	content: number,
	dataKey: string,
): Promise<boolean> => (
	blpAuth.delete({
		url: `/v3/greenroom/${channel}/content-chip/${content}/key/${dataKey}`,
		host: getApiHost(),
		token: blpAuth.accessToken,
		options: { headers: getEmbedSafeHeaders() },
	}).catch((err) => {
		logger.error('Error', err);
		return false;
	}).then((res) => {
		return res.status === 200;
	})
);

export const DeleteChipset = (
	channel: number,
	content: number,
): Promise<boolean> => (
	blpAuth.delete({
		url: `/v3/greenroom/${channel}/content-chipset/${content}`,
		host: getApiHost(),
		token: blpAuth.accessToken,
		options: { headers: getEmbedSafeHeaders() },
	}).catch((err) => {
		logger.error('Error', err);
		return false;
	}).then((res) => {
		return res.status === 200;
	})
);

export const GetContentChipsDraft = (
	roomId: number,
	contentId: number,
): Promise<Entity | null> => (
	blpAuth.get({
		url: `/v1/room/${roomId}/content-chips/${contentId}/draft`,
		host: getSyncHost(),
		token: blpAuth.accessToken,
		options: { headers: getEmbedSafeHeaders() },
	}).then((res) => {
		return res ?? null;
	}).catch((err) => {
		logger.error('Error', err);
		return null;
	})
);

export const UpsertContentChipsDraft = (
	roomId: number,
	contentId: number,
	chipset: Chipset | null,
): Promise<boolean> => (
	blpAuth.put({
		url: `/v1/room/${roomId}/content-chips/${contentId}/draft`,
		host: getSyncHost(),
		token: blpAuth.accessToken,
		options: { headers: getEmbedSafeHeaders() },
		body: { chipset },
	}).then((res) => {
		return res.status === 200;
	}).catch((err) => {
		logger.error('Error', err);
		return false;
	})
);